import { Link } from 'react-router-dom';

import sanitiseProps from '/shared/util/sanitiseProps';

// The fact I have to do this is insane, but hopefully one day Styled Components
// will just work with what it's given.
function SwallowedLink(props: React.ComponentProps<typeof Link>) {
  const otherProps = sanitiseProps(props);
  return <Link {...otherProps} />;
}

export default SwallowedLink;
